import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';

export const InputNodeView = memo(function InputNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="flow-node flow-node--terminal rounded-full border-2 border-teal-500 bg-teal-50 shadow-sm">
      <div className="flow-node__title text-center font-semibold text-teal-700">{getNodeDisplayLabel('input', displayLanguage)}</div>
      <Handle type="source" position={Position.Right} className="!bg-teal-500" />
    </div>
  );
});